module.exports = __webpack_public_path__ + "img/main.e09a98d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main.jpg
// module id = GeQU
// module chunks = 0